// 格式化时间
function formatTime(time) {
    let year = time.getFullYear();
    let month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : "0" + (time.getMonth() + 1);
    let day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
    let hour = time.getHours() > 9 ? time.getHours() : "0" + time.getHours();
    let minute = time.getMinutes() > 9 ? time.getMinutes() : "0" + time.getMinutes();
    let sec = time.getSeconds() > 9 ? time.getSeconds() : "0" + time.getSeconds();

    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + sec;
}

export default {
    formatTime
}


// WEBPACK FOOTER //
// ./src/utils/utils.js